import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { useScrollViewFullHeight } from 'state/scroll/hooks';

/**
 * Determines if the menu screen should be full height.
 * Full height screens changes the scrolling behavior on WEB.
 * Should be called on all menu screens, because is executed on mount/remount.
 */
export const useMenuScroll = () => {
  const isDesktop = useIsDesktopBreakpoint();

  // Switching between mobile and desktop is a known issue
  // we are not going to take into account.
  const skipEffect = () => {
    return isDesktop;
  };

  useScrollViewFullHeight(skipEffect);
};
